import { apiClient } from "./api";

export const clientsService = {
  list: (params = {}) => apiClient.get("/clients", { params }).then((r) => r.data),
  summary: () => apiClient.get("/clients/summary").then((r) => r.data),
  create: (body) => apiClient.post("/clients", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/clients/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/clients/${id}`).then((r) => r.data),
  checkDuplicate: (params) => apiClient.get("/clients/check-duplicate", { params }).then((r) => r.data),
};

export const storesService = {
  list: (params = {}) => apiClient.get("/stores", { params }).then((r) => r.data),
  summary: () => apiClient.get("/stores/summary").then((r) => r.data),
  create: (body) => apiClient.post("/stores", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/stores/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/stores/${id}`).then((r) => r.data),
  checkDuplicate: (params) => apiClient.get("/stores/check-duplicate", { params }).then((r) => r.data),
};

export const usersService = {
  list: (params = {}) => apiClient.get("/users", { params }).then((r) => r.data),
  summary: () => apiClient.get("/users/summary").then((r) => r.data),
  create: (body) => apiClient.post("/users", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/users/${id}`, body).then((r) => r.data),
  checkDuplicate: (params) => apiClient.get("/users/check-duplicate", { params }).then((r) => r.data),
  resendInvite: (id) => apiClient.post(`/users/${id}/resend-invitation`).then((r) => r.data),
  revokeInvite: (id) => apiClient.post(`/users/${id}/revoke-invitation`).then((r) => r.data),
};

export const vaAgenciesService = {
  list: (params = {}) => apiClient.get("/va-agencies", { params }).then((r) => r.data),
  summary: () => apiClient.get("/va-agencies/summary").then((r) => r.data),
  create: (body) => apiClient.post("/va-agencies", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/va-agencies/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/va-agencies/${id}`).then((r) => r.data),
};

export const warehousesService = {
  list: (params = {}) => apiClient.get("/warehouses", { params }).then((r) => r.data),
  summary: () => apiClient.get("/warehouses/summary").then((r) => r.data),
  create: (body) => apiClient.post("/warehouses", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/warehouses/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/warehouses/${id}`).then((r) => r.data),
};

export const ordersService = {
  list: (params = {}) => apiClient.get("/orders", { params }).then((r) => r.data),
  summary: () => apiClient.get("/orders/summary").then((r) => r.data),
  create: (body) => apiClient.post("/orders", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/orders/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/orders/${id}`).then((r) => r.data),
  ship: (id) => apiClient.post(`/orders/${id}/ship`).then((r) => r.data),
  bulkShip: (ids) => apiClient.post("/orders/bulk-ship", { ids }).then((r) => r.data),
  quantityProblem: (id) => apiClient.post(`/orders/${id}/quantity-problem`).then((r) => r.data),
  didntArrive: (id) => apiClient.post(`/orders/${id}/didnt-arrive`).then((r) => r.data),
  reset: (id) => apiClient.post(`/orders/${id}/reset`).then((r) => r.data),
  addNote: (id, message) => apiClient.post(`/orders/${id}/notes`, { message }).then((r) => r.data),
  checkDuplicate: (params) => apiClient.get("/orders/check-duplicate", { params }).then((r) => r.data),
};

export const inventoryService = {
  list: (params = {}) => apiClient.get("/inventory", { params }).then((r) => r.data),
  summary: () => apiClient.get("/inventory/summary").then((r) => r.data),
  create: (body) => apiClient.post("/inventory", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/inventory/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/inventory/${id}`).then((r) => r.data),
  checkDuplicate: (params) => apiClient.get("/inventory/check-duplicate", { params }).then((r) => r.data),
  adjust: (id, body) => apiClient.post(`/inventory/${id}/adjust`, body).then((r) => r.data),
  transactions: (id) => apiClient.get(`/inventory/${id}/transactions`).then((r) => r.data),
};

export const inboundService = {
  list: (params = {}) => apiClient.get("/inbound", { params }).then((r) => r.data),
  summary: () => apiClient.get("/inbound/summary").then((r) => r.data),
  create: (body) => apiClient.post("/inbound", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/inbound/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/inbound/${id}`).then((r) => r.data),
  confirm: (id, products) => apiClient.post(`/inbound/${id}/confirm`, { products }).then((r) => r.data),
  problem: (id) => apiClient.post(`/inbound/${id}/problem`).then((r) => r.data),
};

export const returnsService = {
  list: (params = {}) => apiClient.get("/returns", { params }).then((r) => r.data),
  summary: () => apiClient.get("/returns/summary").then((r) => r.data),
  create: (body) => apiClient.post("/returns", body).then((r) => r.data),
  update: (id, body) => apiClient.put(`/returns/${id}`, body).then((r) => r.data),
  remove: (id) => apiClient.delete(`/returns/${id}`).then((r) => r.data),
  confirm: (id, products) => apiClient.post(`/returns/${id}/confirm`, { products }).then((r) => r.data),
  uploadImages: (id, files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append("files", f));
    return apiClient
      .post(`/returns/${id}/images`, fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  deleteImage: (id, path) => apiClient.post(`/returns/${id}/delete-image`, { path }).then((r) => r.data),
};

export const invoicingService = {
  generate: (body) => apiClient.post("/invoicing/summary", body).then((r) => r.data),
};

export const activityService = {
  list: (params = {}) => apiClient.get("/activity", { params }).then((r) => r.data),
};
